<!-- Desktop Sidebar Navigation (hidden on mobile) -->
<nav class="desktop-sidebar">
  <div class="sidebar-content">
    <!-- Logo -->
    <div class="sidebar-logo">
      <ion-text class="ss-logo">{{ appName }}</ion-text>
    </div>

    <!-- Main Navigation -->
    <div class="sidebar-nav">
      <button
        class="nav-item"
        [class.active]="activeSection === 'home'"
        (click)="navigateToTab('home')"
        >
        <ion-icon [src]="activeSection === 'home' ? '/assets/ic-trend.svg' : '/assets/ic-trend-outline.svg'"></ion-icon>
        <span>Home</span>
      </button>

      <button
        class="nav-item"
        [class.active]="activeSection === 'discover'"
        (click)="navigateToTab('discover')"
        >
        <ion-icon [src]="activeSection === 'discover' ? '/assets/ic-search-filled.svg' : '/assets/ic-search-outline.svg'"></ion-icon>
        <span>Discover</span>
      </button>

      <button
        class="nav-item"
        [class.active]="activeSection === 'donate'"
        (click)="navigateToTab('donate')"
        >
        <ion-icon [name]="activeSection === 'donate' ? 'heart' : 'heart-outline'"></ion-icon>
        <span>Donate</span>
      </button>

      <button
        class="nav-item"
        [class.active]="activeSection === 'sunny-drives'"
        (click)="navigateToTab('sunny-drives')"
        >
        <ion-icon [name]="activeSection === 'sunny-drives' ? 'sunny' : 'sunny-outline'"></ion-icon>
        <span>Drives</span>
      </button>

      <button
        class="nav-item"
        [class.active]="activeSection === 'commerce'"
        (click)="navigateToTab('commerce')"
        >
        <ion-icon [src]="activeSection === 'commerce' ? '/assets/ic-bag.svg' : '/assets/ic-bag-outline.svg'"></ion-icon>
        <span>Shop</span>
      </button>
    </div>

    @if (loggedInUser && rolesLoaded) {
      <div class="sidebar-bottom">
        @if ((permittedCharities?.length ?? 0) > 0) {
          <button
            class="sidebar-action-btn charity-btn"
            (click)="sidebarSwitchToCharity()"
            [disabled]="isSwitchingToCharity || isSwitchingToBusiness"
            >
            <ion-icon name="swap-horizontal-outline"></ion-icon>
            <span>Charity Portal</span>
          </button>
        }
        @if ((permittedBusinesses?.length ?? 0) > 0) {
          <button
            class="sidebar-action-btn business-btn"
            (click)="sidebarSwitchToBusiness()"
            [disabled]="isSwitchingToCharity || isSwitchingToBusiness"
            >
            <ion-icon name="swap-horizontal-outline"></ion-icon>
            <span>Business Portal</span>
          </button>
        }
        <button class="sidebar-action-btn logout-btn" (click)="sidebarSignOut()">
          <ion-icon name="log-out-outline"></ion-icon>
          <span>Log Out</span>
        </button>
      </div>
    }
  </div>
</nav>

<!-- Desktop Header (separate from mobile, hidden on mobile) -->
<header class="desktop-header">
  <div class="header-start">
    @if (!isMainPage) {
      <button class="header-back-btn" (click)="back()" aria-label="Go back">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </button>
    }
    @if (pageTitle) {
      <h2 [class]="pageTitleClass">{{ pageTitle }}</h2>
    }
  </div>
  <div class="header-end">
    @if (!loggedInUser && !loadingUser) {
      <button
        class="header-auth-btn primary"
        (click)="logInModal()"
        >
        Log In
      </button>
    }
    @if (!loggedInUser && !loadingUser) {
      <button
        class="header-auth-btn outline"
        (click)="signUpModal()"
        >
        Sign Up
      </button>
    }
    @if (loggedInUser && currentTab !== 'donate') {
      <button
        class="header-icon-btn notification-btn"
        (click)="goToNotificationsPage()"
        aria-label="Notifications"
        >
        <ion-icon name="notifications-outline"></ion-icon>
        @if (notificationCount > 0) {
          <span class="notification-badge">{{ notificationCount }}</span>
        }
      </button>
    }
    @if (loggedInUser && currentTab === 'commerce') {
      <button
        class="header-icon-btn notification-btn cart-btn"
        (click)="goToCart()"
        aria-label="Cart"
        >
        <ion-icon name="cart-outline"></ion-icon>
        @if (cartBadgeCount > 0) {
          <span class="notification-badge">{{ cartBadgeCount }}</span>
        }
      </button>
    }
    @if (loggedInUser && currentTab === 'donate') {
      <button
        class="header-icon-btn donation-history-btn"
        (click)="goToDonationHistory()"
        aria-label="Donation history"
        >
        <ion-icon name="time-outline"></ion-icon>
      </button>
    }
    @if (loggedInUser && currentTab === 'donate') {
      <button
        class="header-icon-btn donation-schedule-btn"
        (click)="goToRecurringDonations()"
        aria-label="Donation schedule"
        >
        <ion-icon name="calendar-outline"></ion-icon>
      </button>
    }
    @if (loggedInUser) {
      <button
        class="header-avatar-btn"
        (click)="goToMenuPage()"
        aria-label="Menu"
        >
        <div class="avatar-wrapper">
          <ion-img
            [src]="loggedInUser?.avatarUrl"
            alt="Profile"
          ></ion-img>
        </div>
      </button>
    }
  </div>
</header>

<!-- Mobile Header (hidden on desktop) -->
<ion-header class="ion-no-border mobile-header">
  <ion-toolbar class="main-toolbar">
    <ion-buttons slot="start">
      @if (!isMainPage) {
        <ion-button class="btn-back" (click)="back()" (keydown)="back()" tabindex="{0}">
          <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
        </ion-button>
      }
      @if (!pageTitle) {
        <ion-text class="ss-logo">{{ appName }}</ion-text>
      }
      @if (pageTitle) {
        <div class="page-title">
          <h2 [class]="pageTitleClass">{{ pageTitle }}</h2>
        </div>
      }
    </ion-buttons>

    <ion-buttons slot="end">
      @if (!loggedInUser && !loadingUser) {
        <ion-button
          (click)="logInModal()"
          (keydown)="logInModal()"
          tabindex="{0}"
          color="primary"
          shape="round"
          class="auth-btn"
          fill="solid"
          >
          <ion-text>Log In</ion-text>
        </ion-button>
      }
      @if (!loggedInUser && !loadingUser) {
        <ion-button
          (click)="signUpModal()"
          (keydown)="signUpModal()"
          tabindex="{0}"
          color="primary"
          shape="round"
          class="auth-btn"
          fill="solid"
          >
          <ion-text>Sign Up</ion-text>
        </ion-button>
      }
      @if (loggedInUser && currentTab !== 'donate') {
        <ion-button
          (click)="goToNotificationsPage()"
          class="btn-ic-notification"
          fill="clear"
          >
          <ion-icon slot="icon-only" name="notifications"></ion-icon>
          @if (notificationCount > 0){
            <ion-badge color="danger" class="icon-badge">{{ notificationCount }}</ion-badge>
          }
        </ion-button>
      }
      @if (loggedInUser && currentTab === 'commerce') {
        <ion-button
          (click)="goToCart()"
          class="btn-ic-notification btn-ic-cart"
          fill="clear"
          aria-label="Cart"
          >
          <ion-icon slot="icon-only" name="cart-outline"></ion-icon>
          @if (cartBadgeCount > 0){
            <ion-badge color="danger" class="icon-badge">{{ cartBadgeCount }}</ion-badge>
          }
        </ion-button>
      }
      @if (loggedInUser && currentTab === 'donate') {
        <ion-button
          (click)="goToDonationHistory()"
          class="btn-ic-history"
          fill="clear"
          aria-label="Donation history"
          >
          <ion-icon slot="icon-only" name="time-outline"></ion-icon>
        </ion-button>
      }
      @if (loggedInUser && currentTab === 'donate') {
        <ion-button
          (click)="goToRecurringDonations()"
          class="btn-ic-schedule"
          fill="clear"
          aria-label="Donation schedule"
          >
          <ion-icon slot="icon-only" name="calendar-outline"></ion-icon>
        </ion-button>
      }
      @if (loggedInUser) {
        <ion-button
          (click)="goToMenuPage()"
          class="btn-ic-menu"
          fill="clear"
          >
          <div class="profile-avatar image-wrapper circle">
            @if (!imageLoaded) {
              <ion-skeleton-text animated></ion-skeleton-text>
            }
            <ion-img
              alt="avatar"
              [src]="loggedInUser?.avatarUrl"
              (ionImgDidLoad)="imageLoaded = true"
              class="{{!imageLoaded ? 'hidden' : 'fade-in'}}"
            ></ion-img>
          </div>
        </ion-button>
      }
    </ion-buttons>
  </ion-toolbar>
</ion-header>

@if (winningBanner) {
  <div
    class="ss-banner"
    tabindex="0"
    (keyup.enter)="goToCart()"
    (click)="goToCart()">
    <div class="banner-inner">
      <div class="banner-icon-wrapper">
        <ion-icon name="alert-circle"></ion-icon>
      </div>
      <div class="banner-text">
        <span class="banner-title">Pending Payment</span>
        <span class="banner-subtitle">Some items need your attention</span>
      </div>
      <span class="banner-cta">
        See all
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </span>
    </div>
  </div>
}

<!-- Main content area with tabs -->
<div class="main-content-wrapper">
  <ion-tabs (ionTabsWillChange)="handleTabChange($event)">
    <!-- Mobile Tab Bar (hidden on desktop) -->
    <ion-tab-bar slot="bottom" class="mobile-tab-bar">
      <ion-tab-button tab="home" [selected]="currentTab === 'home'">
        <ion-icon
          [src]="currentTab === 'home' ? '/assets/ic-trend.svg' : '/assets/ic-trend-outline.svg'"
        ></ion-icon>
        <ion-label>Home</ion-label>
      </ion-tab-button>

      <ion-tab-button tab="discover" [selected]="currentTab === 'discover'">
        <ion-icon
          [src]="
            currentTab === 'discover'
              ? '/assets/ic-search-filled.svg'
              : '/assets/ic-search-outline.svg'
          "
        ></ion-icon>
        <ion-label>Discover</ion-label>
      </ion-tab-button>

      <ion-tab-button tab="donate" [selected]="currentTab === 'donate'">
        <ion-icon [name]="currentTab === 'donate' ? 'heart' : 'heart-outline'"></ion-icon>
        <ion-label>Donate</ion-label>
      </ion-tab-button>

      <ion-tab-button tab="sunny-drives" [selected]="currentTab === 'sunny-drives'">
        <ion-icon [name]="currentTab === 'sunny-drives' ? 'sunny' : 'sunny-outline'"></ion-icon>
        <ion-label>Drives</ion-label>
      </ion-tab-button>

      <ion-tab-button tab="commerce" [selected]="currentTab === 'commerce'">
        <ion-icon
          [src]="currentTab === 'commerce' ? '/assets/ic-bag.svg' : '/assets/ic-bag-outline.svg'"
        ></ion-icon>
        <ion-label>Shop</ion-label>
      </ion-tab-button>
    </ion-tab-bar>
  </ion-tabs>
</div>
